import style from './index.module.scss';
import cn from 'classnames';
import ViewImg from 'components/image/cdnImage';
import { cdnImgPath } from 'constants/index';
import { CSSProperties, forwardRef, useState, useImperativeHandle } from 'react';
interface IProps {
  className?: string;
  propsStyle?: CSSProperties;
  hotWords?: string[];
  onStartSearch: (val: string) => void;
  placeholder?: string;
  hideHotWord?: boolean;
}
const Home = (props: IProps, ref: React.Ref<unknown>) => {
  const { className, propsStyle, hotWords, placeholder = '请输入你的问题', onStartSearch } = props;
  const [val, setVal] = useState('');

  useImperativeHandle(ref, () => ({
    setValue: (val: string) => {
      setVal(val);
    },
  }));

  const onChange = (e: any) => {
    setVal(e.target.value);
  };
  const onClear = () => {
    setVal('');
    onStartSearch('');
  };
  const onPress = (event: any) => {
    if (event.keyCode === 13) {
      onStartSearch(val);
    }
  };

  const onSearchHotWord = (word: string) => {
    setVal(word);
    onStartSearch(word);
  };
  return (
    <div className={cn(style.search, !!className && className)} style={propsStyle ?? {}}>
      <div className={style.searchContent}>
        <input className={style.searchInput} value={val} type="text" maxLength={30} placeholder={placeholder} autoComplete="off" onChange={onChange} onKeyUp={onPress} />
        {val && <ViewImg click={onClear} className={style.clearImg} src={`${cdnImgPath}/support/faq/pc/clear-icon.png`} />}
        <button className={style.searchBtn} onClick={() => onStartSearch(val)}>
          <ViewImg className={style.searchIcon} src={`${cdnImgPath}/support/faq/pc/search-icon.png`} />
        </button>
      </div>
      {hotWords && (
        <div className={style.hot}>
          <p className={style['for-pc']}>热门搜索词：</p>
          <p className={style['for-mobile']}>热门搜索词</p>
          {hotWords.map(word => (
            <span key={word} className={style.hotWord} onClick={() => onSearchHotWord(word)}>
              {word}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default forwardRef(Home);
